<template>
  <div id="contenedor-eliminar-event">
    <v-card>
      <v-card-title>
        Eliminar evento {{ evento.nombre }}
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p>¿Estás seguro de que deseas eliminar el evento <strong>{{ evento.nombre }}</strong>?</p>
        <p>Esta acción no se puede deshacer.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="handleEliminarEvento"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar Evento">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixSendEmail from '@/helpers/mixSendEmail';
import mixAgendaContrato from './mixAgendaContrato';

export default {
  name: 'EliminarEvento',
  mixins: [mixAgendaContrato, mixSendEmail],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    numeroContrato: {
      type: String,
      required: false,
    },
    evento: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    async handleEliminarEvento() {
      if (this.evento.invitados.length > 0) {
        await this.mixSendEmail({
          to: this.evento.invitados,
          subject: `⚠️ Actualización: Cancelación de evento: ${this.evento.nombre} - ${this.numeroContrato}`,
          text: `Estimados, el evento es para ${this.evento.asunto} el ${this.evento.fecha} a las ${this.evento.hora}. En ${this.evento.lugar}.`,
        });
      }
      await this.mixEliminarAgenda(this.evento.id);
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
